import * as _ from 'lodash';

const twoSeventySpecialtySubkeys = [
  'tin',
  'service_type_code',
  'place_of_service'
];

const loopFieldKeys = [
  'c_loop_fields',
  'd_loop_fields'
];

const loopFields = [
  'member_id',
  'first_name',
  'last_name',
  'date_of_birth'
];

const twoSeventyFields = [
  'org_name',
  'identification_code',
  'origin_company_id',
  'member_id_required',
  'two_seventy_class',
  'gateway_class',
  'has_test_env',
  'send_cpt_code',
  'cpt_code_prefix',
  'send_d_loop_for_dependents'
];

const infoFields = [
  'payer_id',
  'payer_cd',
  'payer_nm',
  'active_flg',
  'allow_group_mover_flg',
  'supported_service_specialties_list'
];

const groupMappingFields = [
  'reference_qualifier',
  'group_handler_class',
  'group_id_pattern'
];

const costRulesFields = [
  'deductible_waived',
  'copay_only_fee_for_service',
  'charge_full_when_missing_ebs',
  'copay_counts_towards_oop',
  'payment_methods'
];

const paymentMethodFields = ['default', 'when_deductible_is_waived', 'when_hdhp'];

const accumSubKeyFields = {
  eb_fields: [
    'eb_code',
    'service_type_code',
    'time_period',
    'in_network',
    'cpt_code',
    'plan_name'
  ],
  messages: [
    'include',
    'exclude'
  ],
  custom_filters: ['custom_filters']
};

const accumKeys = [
  'active_coverage',
  'coinsurance',
  'copay',
  'deductible',
  'deductible_waived',
  'oop',
  'hra',
  'hdhp',
  'zero_cost',
  'full_cost'
];

const accumSubKeys = ['eb_fields', 'messages', 'custom_filters'];

const chronicCareKeys = [
  'CHRONICKIDNEYDISEASE',
  'DIABETES',
  'DIABETESCARE',
  'DIABETESFLEX',
  'DIABETESCKDVARIANT',
  'HEARTFAILURE',
  'HYPERTENSION',
  'HYPERTENSIONCARE',
  'HYPERTENSIONCKDVARIANT',
  'MYMENTALHEALTH',
  'MYMENTALHEALTH1',
  'MYMENTALHEALTH2',
  'MYMENTALHEALTHCOMP',
  'MYSTRENGTHPLUS',
  'PREDIABETES',
  'WEIGHTMANAGEMENT'
];
const specialtyKeys = ['GENMEDICAL', 'BEHAVHEALTH', 'DERM', 'NUTRITION', 'VPC'];
const twoSeventyOneKeys = [...specialtyKeys, ...chronicCareKeys];

const editableAccums = ['active_coverage', 'coinsurance', 'copay',
  'deductible', 'oop', 'max_out_of_pocket'];

const hiddenAccums = ['deductible_waived', 'fully_insured'];

const getSpecialityAccums = speciality => {
  if (!speciality) return [];

  if (specialtyKeys.includes(speciality)) return accumKeys;

  if (chronicCareKeys.includes(speciality)) return [accumKeys[0]];

  return [];
};

const fieldHints = {
  eb_code:           'eb_code hint',
  service_type_code: 'service_type_code hint',
  time_period:       'time_period hint',
  in_network:        'in_network hint',
  cpt_code:          'cpt_code hint',
  plan_name:         'plan_name hint',
  include:           'include hint',
  exclude:           'exclude hint',
  custom_filters:    'custom_filters hint'
};

const isEditable = accumName => _.includes(editableAccums, accumName);

const isHidden = accumName => _.includes(hiddenAccums, accumName);

const generateName = keys => keys.join('.');

const transformName = name => name.toString()
  .split('_')
  .map(s => s.charAt(0).toUpperCase() + s.slice(1))
  .join(' ');

const displayCustomFilter = (settings, accum, accumSubKey) => {
  if (settings && settings[accum]) {
    return settings[accum][accumSubKey] ? settings[accum][accumSubKey] : '';
  } else {
    return '';
  }
};

const displaySpecialtyStatus = (settings, specialty) => {
  if (!_.has(settings, specialty)) {
    return ' --- NOT Enabled ---';
  }
  return '';
};

const displaySetting = (setting = '') => setting;

const displaySettings = (settings, accum, accumSubKey, accumSubKeyField) => {
  const value = _.get(settings, [accum, accumSubKey, accumSubKeyField]);
  if (value) {
    return JSON.stringify(value);
  }
  return '';
};

const arrayToCsv = value => {
  if (value === '') {
    return '';
  }
  let result;
  try {
    if (_.isArray(value)) {
      // eslint-disable-next-line
      return value.map(v => v === '' ? '\"\"' : v).join(',');
    }
    // eslint-disable-next-line
    result = JSON.parse(value).map(v => v === '' ? '\"\"' : v).join(',');
  } catch (e) {
    if (!Number.isNaN(+value)) {
      return value;
    } else if (typeof value === 'string') {
      return value.split('"').join('');
    }
    return '';
  }
  return result;
};

const modifyArrayValue = arrayValue => {
  const result = arrayValue.toString().split(',');
  if (result.length === 1 && result[0] === '') {
    return '';
  }
  return result.map(s => {
    if (s.trim() === '""') {
      return '';
    }
    return s.trim();
  });
};

const fieldHint = name => fieldHints[name];

const transformErrorMessage = msg => {
  if (!msg || _.isEmpty(msg)) {
    return '';
  }
  const [fieldNames, ...error] = msg.split(' ');
  return `${transformName(_.last(fieldNames.split('.')))} ${error.join(' ')}`;
};

export default {
  transformName,
  twoSeventyOneKeys,
  specialtyKeys,
  chronicCareKeys,
  accumKeys,
  accumSubKeys,
  accumSubKeyFields,
  displayCustomFilter,
  displaySetting,
  displaySettings,
  displaySpecialtyStatus,
  generateName,
  arrayToCsv,
  modifyArrayValue,
  fieldHint,
  costRulesFields,
  paymentMethodFields,
  groupMappingFields,
  infoFields,
  twoSeventySpecialtySubkeys,
  loopFieldKeys,
  loopFields,
  twoSeventyFields,
  isEditable,
  isHidden,
  transformErrorMessage,
  getSpecialityAccums
};
